/**
 * KCB 휴대폰 본인인증 API
 * OpenAPI Generator로 생성된 타입을 사용하며, 기존 Axios 인스턴스와 통합
 */
export class KcbPhoneVerificationService {
    constructor(axiosInstance) {
        Object.defineProperty(this, "axios", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.axios = axiosInstance;
    }
    /**
     * 휴대폰 본인인증 거래 시작
     * KCB 휴대폰 본인인증 거래를 시작하고 모듈 토큰을 발급받는다. 발급받은 토큰으로 KCB 팝업을 호출한다.
     * @returns 휴대폰 본인인증 거래 시작 결과
     */
    startVerification(request) {
        return this.axios.post(`/main/v1/kcbs/verify/start`, request);
    }
    /**
     * 휴대폰 본인인증 결과 수신
     * KCB 팝업에서 인증 완료 후 모듈 토큰으로 인증 결과를 조회한다. DI/CI 및 개인정보를 수신한다.
     * @returns 휴대폰 본인인증 결과 수신 결과
     */
    getVerificationResult(request) {
        return this.axios.post(`/main/v1/kcbs/verify/result`, request);
    }
}
//# sourceMappingURL=kcbphoneverification.service.js.map